import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { LadderIcon } from "./icons/LadderIcon";
import type { Ladder } from "../types";

const LadderTitleContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "10px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  svg: {
    position: "relative",
    top: "5px",
  },
  [theme.breakpoints.down("sm")]: {
    top: "80px",
    left: "20px",
    right: "20px",
    textAlign: "center",
    whiteSpace: "wrap",
    textOverflow: "wrap",
  },
}));

export const LadderTitle = ({ ladder }: { ladder: Ladder }) => {
  const theme = useTheme();
  return (
    <LadderTitleContainer>
      <Typography
        color={
          (
            theme.palette as unknown as Record<
              string,
              { rootActiveColor?: string }
            >
          )?.item?.rootActiveColor ?? theme.palette.primary.main
        }
        variant="h5"
        sx={{ width: "100%", textAlign: "left" }}
      >
        <LadderIcon width={24} height={24} />
        {ladder.name}
      </Typography>
    </LadderTitleContainer>
  );
};
